module.exports = __webpack_public_path__ + "static/media/warning.271e4799.svg";